<!-- Navigation button template content -->
<ng-template #navContentTemplate>
  <span class="d-block asset-container flex-shrink-0" *ngIf="imgUrl || isTextIndent || usePlaceholder">
    <ng-container *ngIf="imgUrl || usePlaceholder">
      <shrd-uic-image
        *ngIf="!showWarningIndicator; else tplWithIndicator"
        [containerClass]="isImageCoverMode ? 'image-container-cover' : null"
        [src]="imgUrl"
        [alt]="imgAlt"
        [usePlaceholder]="usePlaceholder"
        [maxHeight]="maxImgSize"
        [maxWidth]="maxImgSize"
        [alignY]="isTopAligned ? 'top' : null"
      ></shrd-uic-image>
      <ng-template #tplWithIndicator>
        <shrd-uic-image
          [containerClass]="isImageCoverMode ? 'image-container-cover' : null"
          [src]="imgUrl"
          [alt]="imgAlt"
          [usePlaceholder]="usePlaceholder"
          [maxHeight]="maxImgSize"
          [maxWidth]="maxImgSize"
          [alignY]="isTopAligned ? 'top' : null"
          [shrdUtcWarningIndicator]="showWarningIndicator"
          [shrdUtcWarningIndicatorImageVariant]="useImageVariant"
          [shrdUtcWarningIndicatorBreakpointMax]="maxBreakpoint"
        ></shrd-uic-image>
      </ng-template>
    </ng-container>
  </span>
  <span class="d-block nav-button-text-block text-start" [ngClass]="{ selected: isSelected, text: isTopAligned }">
    <span class="nav-button-text-headline text-bold" *ngIf="headlineText">{{ headlineText }}</span>
    <span class="nav-button-text-label" *ngIf="label">{{ label }}</span>
    <ng-content></ng-content>
  </span>
</ng-template>

<!-- Button container wrapper -->
<button
  class="nav-button btn-link"
  [ngClass]="isTopAligned ? 'nav-top-aligned' : 'nav-center-aligned'"
  *ngIf="!url; else navLinkTemplate"
  [disabled]="disabled"
>
  <ng-container *ngTemplateOutlet="navContentTemplate"></ng-container>
</button>

<!-- Link template wrapper -->
<ng-template #navLinkTemplate>
  <!-- router link has a separate wrapper, as it doesn't support conditional states -->
  <div [ngSwitch]="urlType" [ngClass]="isTopAligned ? 'nav-top-aligned' : 'nav-center-aligned'">
    <a
      class="nav-button btn-link"
      *ngSwitchCase="'routerLink'"
      [routerLink]="url"
      [ngClass]="{ 'btn-link-noimage': !imgUrl && !usePlaceholder }"
    >
      <ng-container *ngTemplateOutlet="navContentTemplate"></ng-container>
    </a>
    <a
      class="nav-button btn-link"
      *ngSwitchDefault
      target="_self"
      [href]="url"
      [ngClass]="{ 'btn-link-noimage': !imgUrl && !usePlaceholder }"
    >
      <ng-container *ngTemplateOutlet="navContentTemplate"></ng-container>
    </a>
  </div>
</ng-template>
